import React from "react";
import {Tag} from "antd";
import {mapChannels} from "../Shared/useTenantChannels";

// We want to have different display text in the dropdown row vs the Tag so rendering it custom
export default function CustomCelebrationTag({
    originalTagRenderProps,
    getTenantChannelsQuery
  }) {
    const { label, value, closable, onClose } = originalTagRenderProps;
    const teamId = value;
    const newChannelArray = mapChannels(getTenantChannelsQuery.data);
    const foundChannelData = newChannelArray.find((channelData) => {
        return channelData.id === teamId;
    })
    // Lets fallback on label if the channel is not found for some reason
    const displayText = foundChannelData ? `${foundChannelData.teamName} - ${foundChannelData.displayName}` : label;
    return <Tag
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
    >
        {displayText}
    </Tag>;
  }
  